{
  "AUTH_INVALID_CREDENTIALS": "Email ou senha inválidos.",
  "AUTH_ACCOUNT_BLOCKED": "Conta bloqueada.",
  "AUTH_ACCOUNT_INACTIVE": "Conta inativada. Entre em contato com o suporte.",
  "AUTH_USER_NOT_FOUND": "Usuário não encontrado.",
  "AUTH_TWO_FACTOR_REQUIRED": "Código de verificação necessário.",
  "AUTH_TWO_FACTOR_CODE_INVALID": "Código de verificação inválido.",
  "AUTH_TOKEN_INVALID": "Token inválido.",
  "AUTH_TOKEN_EXPIRED": "Token expirado.",
  "AUTH_TOKEN_REQUIRED": "Token é obrigatório.",
  "AUTH_LOGOUT_SUCCESS": "Logout realizado com sucesso.",
  "AUTH_PASSWORD_RESET_REQUESTED": "Se o email existir, você receberá um link para definir a senha.",
  "AUTH_RESET_TOKEN_INVALID": "Token inválido ou expirado.",
  "AUTH_PASSWORD_CHANGED": "Senha alterada com sucesso.",
  "AUTH_PASSWORD_INCORRECT": "Senha incorreta.",
  "AUTH_TWO_FACTOR_ALREADY_ENABLED": "2FA já está ativado.",
  "AUTH_TWO_FACTOR_SETUP_EXPIRED": "Sessão de configuração expirada.",
  "AUTH_CODE_INVALID": "Código inválido.",
  "AUTH_TWO_FACTOR_ENABLED": "2FA ativado com sucesso.",
  "AUTH_TWO_FACTOR_DISABLED": "2FA desativado com sucesso.",
  "AUTH_DEEP_LINK_INVALID": "Token de deep link inválido ou expirado.",
  "AUTH_DEEP_LINK_USED": "Token já utilizado ou expirado.",
  "AUTH_MAGIC_LINK_SENT": "Se o email existir, o magic link foi enviado.",
  "AUTH_MAGIC_LINK_INVALID": "Magic link inválido ou expirado.",
  "AUTH_MAGIC_LINK_LOGIN_SUCCESS": "Login via magic link realizado com sucesso.",
  "AUTH_EMAIL_REQUIRED": "Email é obrigatório.",
  "AUTH_TOO_MANY_LOGIN_ATTEMPTS": "Muitas tentativas de login. Tente novamente em alguns minutos.",
  "AUTH_OAUTH_NOT_CONFIGURED": "{{provider}} OAuth não configurado.",
  "AUTH_OAUTH_PROVIDER_UNSUPPORTED": "Provider não suportado.",
  "AUTH_OAUTH_PROVIDER_INVALID": "Provider inválido.",
  "AUTH_OAUTH_CODE_REQUIRED": "Código de autorização obrigatório.",
  "AUTH_OAUTH_STATE_REQUIRED": "State obrigatório.",
  "AUTH_OAUTH_STATE_INVALID": "State inválido.",
  "AUTH_OAUTH_CODE_OR_STATE_REQUIRED": "Código ou state obrigatório.",
  "AUTH_SOCIAL_CALLBACK_OK": "O endpoint de callback do login social está funcionando.",
  "AUTH_MFA_METHOD_UNAVAILABLE": "Método não disponível.",
  "AUTH_MFA_CODE_COOLDOWN": "Aguarde {{seconds}} segundos antes de solicitar outro código.",
  "AUTH_MFA_PHONE_MISSING": "Telefone não cadastrado.",
  "AUTH_MFA_CODE_SENT": "Código enviado.",
  "AUTH_MFA_TOO_MANY_ATTEMPTS": "Muitas tentativas. Inicie o login novamente.",
  "AUTH_MFA_METHOD_ALREADY_VERIFIED": "Método já verificado.",
  "AUTH_MFA_CODE_INVALID": "Código ou senha inválidos.",
  "AUTH_MFA_SESSION_EXPIRED": "Sessão expirada. Inicie o login novamente.",
  "AUTH_MFA_SESSION_INVALID": "Sessão inválida. Inicie o login novamente.",
  "AUTH_MFA_SESSION_UNAVAILABLE": "Não foi possível continuar o login. Tente novamente em instantes.",
  "AUTH_WEBHOOK_TOKEN_INVALID": "Token do webhook inválido.",
  "AUTH_WEBHOOK_UNAVAILABLE": "Webhook de usuários indisponível: assinatura não configurada.",
  "AUTH_WEBHOOK_SIGNATURE_REQUIRED": "Assinatura do webhook é obrigatória.",
  "AUTH_WEBHOOK_SIGNATURE_INVALID": "Assinatura do webhook inválida.",
  "AUTH_WEBHOOK_SOURCE_REQUIRED": "A origem do webhook é obrigatória.",
  "AUTH_WEBHOOK_USERS_REQUIRED": "Payload inválido: a lista de usuários é obrigatória.",
  "AUTH_WEBHOOK_FIELDS_REQUIRED": "Nome e email são obrigatórios.",
  "AUTH_WEBHOOK_USER_EXISTS": "Usuário já existe com este email.",
  "AUTH_WEBHOOK_USER_CREATE_FAILED": "Falha ao criar o usuário.",
  "AUTH_WEBHOOK_USER_CREATED": "Usuário criado com sucesso via webhook.",
  "AUTH_WEBHOOK_PING_OK": "O endpoint do webhook está funcionando.",
  "AUTH_EMAIL_INVALID": "Email inválido.",
  "AUTH_PASSWORD_TOO_SHORT": "A senha deve ter no mínimo 8 caracteres.",
  "AUTH_PASSWORD_WEAK": "A senha deve conter pelo menos uma maiúscula, uma minúscula e um número.",
  "AUTH_REFRESH_TOKEN_REQUIRED": "Refresh token é obrigatório.",
  "AUTH_TWO_FACTOR_CODE_LENGTH": "O código deve ter 6 dígitos.",
  "AUTH_TWO_FACTOR_BACKUP_CODE_LENGTH": "O código deve ter de 6 a 8 caracteres.",
  "AUTH_MFA_SEND_METHOD_INVALID": "O método deve ser email ou sms.",
  "AUTH_MFA_METHOD_INVALID": "Método inválido.",
  "USER_NOT_FOUND": "Usuário não encontrado.",
  "USER_EMAIL_IN_USE": "Este email já está em uso.",
  "USER_CPF_IN_USE": "Este CPF já está em uso.",
  "USER_BLOCKED": "Usuário bloqueado.",
  "USER_CURRENT_PASSWORD_INCORRECT": "Senha atual incorreta.",
  "USER_DELETED": "Usuário excluído com sucesso.",
  "USER_NAME_TOO_SHORT": "O nome deve ter no mínimo 2 caracteres.",
  "USER_CPF_INVALID": "O CPF deve ter 11 dígitos numéricos.",
  "USER_PHONE_INVALID": "O telefone deve ter 10 ou 11 dígitos.",
  "USER_PHONE_INTERNATIONAL_INVALID": "O telefone deve estar no formato internacional (+ e 8 a 15 dígitos).",
  "TERMS_IP_REQUIRED": "O endereço IP é obrigatório.",
  "TERMS_CONTRACT_FILE_TYPE_INVALID": "Apenas arquivos PDF ou DOC/DOCX são permitidos.",
  "TERMS_CONTRACT_FILE_TOO_LARGE": "O arquivo deve ter no máximo {{maxMb}}MB.",
  "ONBOARDING_PROGRESS_NOT_FOUND": "Progresso do onboarding não encontrado.",
  "ONBOARDING_PROGRESS_ALREADY_EXISTS": "O progresso do onboarding já existe para este usuário.",
  "ONBOARDING_TEMPLATE_NOT_FOUND": "Template não encontrado.",
  "DEVFLIX_SSO_STUDENT_NOT_FOUND": "Aluno ativo não encontrado.",
  "DEVFLIX_SSO_EMAIL_NOT_VERIFIED": "Confirme seu e-mail na área de membros antes de entrar na DevFlix.",
  "DEVFLIX_SSO_CODE_INVALID": "Código de autorização inválido.",
  "DEVFLIX_SSO_NOT_CONFIGURED": "Integração DevFlix não configurada com cliente, segredo e redirects fortes.",
  "DEVFLIX_SSO_CLIENT_NOT_AUTHORIZED": "Cliente ou redirect da DevFlix não autorizado.",
  "DEVFLIX_SSO_CLIENT_UNAUTHENTICATED": "Cliente não autenticado.",
  "DEVFLIX_SSO_SCOPE_INVALID": "Escopo DevFlix inválido.",
  "PLATFORM_OPERATOR_NOT_FOUND": "Operador não encontrado.",
  "PLATFORM_OPERATOR_INACTIVE": "Operador inativo.",
  "PLATFORM_TENANT_NOT_FOUND": "Nenhuma área de membros atende este endereço.",
  "PLATFORM_SCHOOL_NAME_REQUIRED": "Informe o nome da escola.",
  "PLATFORM_ADMIN_EMAIL_REQUIRED": "Informe o e-mail do admin da escola.",
  "PLATFORM_ADMIN_PASSWORD_TOO_SHORT": "A senha inicial do admin precisa de ao menos {{min}} caracteres.",
  "PLATFORM_SUBDOMAIN_INVALID": "Subdomínio inválido.",
  "PLATFORM_SUBDOMAIN_RESERVED": "O subdomínio \"{{slug}}\" é reservado.",
  "PLATFORM_SUBDOMAIN_TAKEN": "O subdomínio \"{{slug}}\" já está em uso.",
  "PLATFORM_SUBDOMAIN_UNAVAILABLE": "Não foi possível derivar um subdomínio livre a partir de \"{{source}}\".",
  "PLATFORM_TENANT_SUSPENDED": "Cliente suspenso.",
  "PLATFORM_TENANT_BLOCKED": "Esta área de membros está bloqueada. Fale com o suporte.",
  "PLATFORM_TENANT_REACTIVATED": "Cliente reativado.",
  "AUTH_INVITE_INVALID": "Link de acesso inválido ou já utilizado.",
  "AUTH_INVITE_EXPIRED": "Link de acesso expirado. Peça um novo link.",
  "AUTH_PASSWORD_NOT_SET": "Você ainda não definiu sua senha. Use o link enviado ao seu e-mail ou recupere o acesso em \"Esqueceu a senha?\".",
  "PLATFORM_PRODUCER_WEBHOOK_SIGNATURE_INVALID": "Assinatura do webhook inválida."
}
